export default "__VITE_ASSET__CXpc$K$n__"